import {Component, OnDestroy} from "@angular/core";
import {FUIAbstractValidation} from "../abstract-validation";
import {Subscription} from "rxjs";

@Component({
    selector: "fui-success-validation",
    styleUrls: ["success-validation.component.scss"],
    templateUrl: "./success-validation.component.html"
})
export class FUISuccessValidationComponent extends FUIAbstractValidation implements OnDestroy {
    private _statusChanges: Subscription;

    override ngOnInit(): void {
        this.validity();
        this._statusChanges = this.control.statusChanges.subscribe(() => this.validity());
    }

    ngOnDestroy(): void {
        this._statusChanges.unsubscribe();
    }

    /**
     *
     */
    override validity(): void {
        if (this.control.dirty || this.control.touched) {
            this.valid = this.control.valid;
        } else {
            this.valid = false;
        }
    }
}
